import $ from 'jquery';
export default class CartItemsCount {
    static $element = $('.js__cart-items-count');
    static set(value) {
        this.$element.attr('data-count', value);
    }
}
